import React, { FC, useEffect, useState } from 'react'
import s from '@pagestyles/Blog.module.scss'
import getAllBlogs, {
    BlogMonthYearBlogCount,
    BlogMothBlogPostCount,
    BlogPostsResult
} from '@pylot-data/api/operations/get-all-blogs'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { MinusIcon, PlusIcon } from '@components/icons'
import { useRouter } from 'next/router'

const DateWisePostFilter: FC = () => {
    const { t } = useTranslation(['blog'])
    const [yearPostList, setYearPostList] = useState<BlogMonthYearBlogCount[]>(
        []
    )
    const [selectedId, setSelectedId] = useState<number | null>(null)
    const publishUrl = '/blog/publish/'
    const router = useRouter()
    const { locale } = router

    useEffect(() => {
        const fetchData = async () => {
            const blogData = await getAllBlogs({ locale: locale || '' })
            if (!blogData) {
                return {
                    notFound: true
                }
            }
            const data: BlogPostsResult = blogData.blogPosts
            generateMonthYearList(data)
        }
        fetchData()
    }, [])

    const generateMonthYearList = (data: BlogPostsResult) => {
        const yearMap: Map<string, Map<string, number>> = new Map<
            string,
            Map<string, number>
        >()
        if (data.items && data.items.length) {
            const years = data.items.map((el) => el.modified_time)
            years.forEach((year) => {
                const yr = new Date(year.replace(/-/g, '/'))
                    .getFullYear()
                    .toString()
                const monthCrr = new Date(
                    year.replace(/-/g, '/')
                ).toLocaleString('default', {
                    month: 'long'
                })
                const monthMap: Map<string, number> = new Map<string, number>()
                monthMap.set(monthCrr, 1)
                if (!yearMap.has(yr)) {
                    yearMap.set(yr, monthMap)
                    return
                }
                if (!yearMap.get(yr)?.has(monthCrr)) {
                    yearMap.get(yr)?.set(monthCrr, 1)
                    return
                }
                const postCount = yearMap.get(yr)?.get(monthCrr)
                yearMap.get(yr)?.set(monthCrr, postCount ? postCount + 1 : 1)
            })
            setSideBarMonthList(yearMap)
        }
    }

    const setSideBarMonthList = (yearMap: Map<string, Map<string, number>>) => {
        const array: BlogMonthYearBlogCount[] = []
        for (const [key, value] of yearMap) {
            array.push({
                year: key,
                monthData: getMonthArr(value)
            })
        }
        setYearPostList(array)
    }

    const getMonthArr = (
        monthMap: Map<string, number>
    ): BlogMothBlogPostCount[] => {
        const monthPostCount: Array<BlogMothBlogPostCount> = []
        for (const [key, value] of monthMap) {
            monthPostCount.push({
                month: key,
                postCount: value
            })
        }
        return monthPostCount
    }

    const handleHideShow = (_index: number) => {
        setSelectedId(selectedId === _index ? null : _index)
    }

    return (
        <div className="monthList">
            <h2>{t('Month List')}</h2>
            <div className={s['categoryList']}>
                {yearPostList.map((item, index) => {
                    return (
                        <div
                            className={s['monthlistData']}
                            key={`year_month_${index}`}
                        >
                            <span
                                className={
                                    selectedId === index ? s['activeMonth'] : ''
                                }
                            >
                                {item.year}
                            </span>
                            <button
                                type="button"
                                onClick={() => handleHideShow(index)}
                            >
                                {selectedId === index ? (
                                    <MinusIcon />
                                ) : (
                                    <PlusIcon />
                                )}
                            </button>
                            {selectedId === index && (
                                <div>
                                    {item.monthData && (
                                        <ul>
                                            {item.monthData.map(
                                                (element, mIndex) => {
                                                    return (
                                                        <li
                                                            key={`month_post_count_${mIndex}`}
                                                        >
                                                            <Link
                                                                href={`${publishUrl}${item.year}-${element.month}`}
                                                            >
                                                                {element.month}
                                                            </Link>
                                                            ({element.postCount}
                                                            )
                                                        </li>
                                                    )
                                                }
                                            )}
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default DateWisePostFilter
